module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_m_normal.26ac4daa.png";